import axios from './api';

export const getInfo = (params: any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserCaseInfo',
    params,
  })
);

export const getPic = (params: any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserCaseHistogram',
    params,
  })
);
